/**
 * The SHELF treatment for a card that must read the same on the phone as in
 * the studio: it draws its OWN plate — the `card` Surface look (surface colour,
 * shadow-1, radius 28, sp-4 padding) — instead of relying on the dashboard
 * shell's panel, because the Flutter shell lays modules flat and a card that
 * depended on that panel sits on the page background there. Every id wrapped
 * here is listed in `OWN_SURFACE` (families.js), which is how the web shell
 * knows not to panel it twice.
 *
 * `.vi-own-card:empty` (KitKeyframes) is the same honesty rule the shell's
 * panel obeys: a card whose content data-gated itself away renders nothing,
 * and the plate must vanish with it rather than leave a raised empty box.
 */
export const OWN_CARD_STYLE = {
  background: 'var(--surface)',
  boxShadow: 'var(--shadow-1)',
  borderRadius: 28,
  padding: 'var(--sp-4)',
  minWidth: 0,
};

export function ownCard(Inner, name) {
  const Wrapped = (p) => (
    <div className="vi-own-card" style={OWN_CARD_STYLE}><Inner {...p} /></div>
  );
  Wrapped.displayName = name;
  return Wrapped;
}
